export default __webpack_public_path__ + "static/media/367.c4704959.gif";